export const CONSTANT = Object.freeze({
  SOCKET_EVENT: 'SOCKET_TRIGGER',

  ROLE_EMPLOYEE: 'ROLE_EMPLOYEE',
  ROLE_MANAGER: 'ROLE_MANAGER',
  ROLE_ADMIN: 'ROLE_ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',

  ROLE_USER_TYPE_OBJ: {
    // 'SUPER_ADMIN': 'superAdmin',
    ROLE_ADMIN: 'admin',
    ROLE_MANAGER: 'manager',
    ROLE_EMPLOYEE: 'employee',
  },

  USER_TYPE_ARRAY: [
    { value: 'admin', label: 'Admin' },
    { value: 'manager', label: 'Manager' },
    { value: 'employee', label: 'Employee' },
  ],
});
